import { DELETE_DATA_USER_MENU, GET_DATA_PERMISSION, GET_DATA_PERMISSION_SUCCEEDED, GET_DATA_USER_MENU, GET_DATA_USER_MENU_SUCCEEDED, ISRESULT, REQUERT_DATA_PERMISSION_FAILED, REQUERT_USER_MENU_FAILED, SET_DATA_USER_MENU } from "./actionsTypes"

export const IsResultAction = (isResult) => {
    return {
        type: ISRESULT,
        isResult: isResult
    }
}

//Menu Role
 export const GetDataPermissionAction = (DataMenu) => {
    return{
        type: GET_DATA_PERMISSION,
        DataMenu: DataMenu
    }
 }

 export const GetDataPermissionSuccessAction = (DataPermission) =>{
     return {
         type: GET_DATA_PERMISSION_SUCCEEDED,
         DataPermission: DataPermission
     }
 }
 export const RequertDataPermissionFailedAction = (Err) =>{
     return {
         type: REQUERT_DATA_PERMISSION_FAILED,
         err: Err
     }
 }

 // User Menu
 export const GetDataUserMenuAction = () => {
    return {
        type: GET_DATA_USER_MENU
    }
}

export const GetDataUserMenuSuccessAction = (DataUserMenu) => {
    return {
        type: GET_DATA_USER_MENU_SUCCEEDED,
        DataUserMenu: DataUserMenu
    }
}

export const RequertUserMenuFailedAction = (Err) =>{
    return {
        type: REQUERT_USER_MENU_FAILED,
        err: Err
    }
}
 export const SetDataUserMenuAction = (DataUserMenu) =>{
     return {
        type: SET_DATA_USER_MENU,
        DataUserMenu: DataUserMenu
     }
 }
 export const DeleteDataUserMenuAction = (ID) =>{
     return {
         type : DELETE_DATA_USER_MENU,
         ID: ID
     }
 }